// extracted by mini-css-extract-plugin
export default {"container":"HowItWorksPanel_container__BuVLn","title":"HowItWorksPanel_title__zpjkZ","submitButton":"HowItWorksPanel_submitButton__w9ZHr"};